export default "__VITE_ASSET__BKcGXeSd__";